/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MemoryStats
 */
export interface MemoryStats {
    /**
     * 
     * @type {number}
     * @memberof MemoryStats
     */
    totalMemory?: number;
    /**
     * 
     * @type {number}
     * @memberof MemoryStats
     */
    freeMemory?: number;
    /**
     * 
     * @type {number}
     * @memberof MemoryStats
     */
    usedMemory?: number;
}

/**
 * Check if a given object implements the MemoryStats interface.
 */
export function instanceOfMemoryStats(value: object): value is MemoryStats {
    return true;
}

export function MemoryStatsFromJSON(json: any): MemoryStats {
    return MemoryStatsFromJSONTyped(json, false);
}

export function MemoryStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemoryStats {
    if (json == null) {
        return json;
    }
    return {
        
        'totalMemory': json['totalMemory'] == null ? undefined : json['totalMemory'],
        'freeMemory': json['freeMemory'] == null ? undefined : json['freeMemory'],
        'usedMemory': json['usedMemory'] == null ? undefined : json['usedMemory'],
    };
}

export function MemoryStatsToJSON(json: any): MemoryStats {
    return MemoryStatsToJSONTyped(json, false);
}

export function MemoryStatsToJSONTyped(value?: MemoryStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalMemory': value['totalMemory'],
        'freeMemory': value['freeMemory'],
        'usedMemory': value['usedMemory'],
    };
}

